import React,{useState} from "react";
import testinomials from "../testinomials"
function Testinomials() {
    const n = testinomials.length;
    // console.log(n);
    const [i,setI] = useState(0);
    const [desc,setDesc] = useState(testinomials[i].desc);
    const [img,setImg] = useState(testinomials[i].img)
    const [name,setName] = useState(testinomials[i].name);
    function handleClick() {
        // console.log(i);
        if(i === n-1){
            setI(0);
        }
        else{
            setI(i+1);
        }
        setDesc(testinomials[i].desc);
        setImg(testinomials[i].img);
        setName(testinomials[i].name);
    }
    function handleClickP() {
        // console.log(i);
        if(i === 0){
            setI(n-1);
        }
        else{
            setI(i-1);
        }
        setDesc(testinomials[i].desc);
        setImg(testinomials[i].img);
        setName(testinomials[i].name);
    }
    return (
        <div className="flex flex-col lg:p-10 lg:gap-7">
            <h2 className="flex uppercase text-3xl md:text-4xl lg:text-5xl justify-center m-7 md:m-0">Testinomials</h2>
            <div className="flex p-4 md:p-8 lg:p-16 justify-center mb-5 md:mb-0">
                <div className="flex p-2 md:p-8 lg:p-16 justify-center md:justify-end">
                    <button onClick={handleClickP}><i class="fa-solid fa-chevron-left"></i></button>
                </div>
                <div className="flex flex-col shadow-xl rounded-2xl p-4 md:p-8 lg:p-12 gap-5 bg-white/80 w-full lg:w-3/5"> 
                    <p className="flex text-justify text-lg md:text-xl">{desc}</p>
                    <div className="flex gap-5">
                        <img className="flex rounded-full w-12 h-auto" src={img} alt="" />
                        <h5 className="flex text-xl">{name}</h5>
                    </div>    
                </div>
                <div className="flex p-2 md:p-8 lg:p-16 justify-center md:justify-start"> 
                    <button onClick={handleClick}><i class="fa-solid fa-chevron-right"></i></button>
                </div>
            </div>
        </div>
    )
}

export default Testinomials;